export default function () {
    return {
        KEYS: {
            PERFORMANCE_REVIEW: 'PERFORMANCE_REVIEW',
            EVALUATION: 'EVALUATION',
            SURVEY: 'SURVEY'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/user/switchLanguageSource/index.js